export const calcPaydayLoanAmts = (loanAmount, interestRate, loanTerm) => {   
    //  loanTerm will be in days (not years)

    //APR = ((finance charge / loan amount) × 365) / term × 100
    //APR = ((230/1500) × 365)/14 × 100  
    //calc1 = APR / 100;    ==>  300 / 100;  
    //calc2 = calc2 * loanTerm;  ==>  3 * 14
    //calc3 = calc2 / 365;  ==>   42 / 365
    //financeCharge = calc3 * loanAmt   .1150 * 1500    ==> 172.50
  
    const calc2Amt = (interestRate * loanTerm) / 100;
    const calc3Amt = calc2Amt / 365;
    const financeCharge = (calc3Amt * loanAmount).toFixed(2);
    return financeCharge;
}

export default calcPaydayLoanAmts;


